@if (isDialog) {
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <span>{{ question?.question }}</span>
      <span class="modal-toolbar-spacer"></span>
      <button mat-icon-button class="ml-auto" (click)="closeDialogue()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
}

<!-- Loading Indicator -->
@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
} @else {
  <div [ngClass]="isDialog ? 'container mt-5' : ''">
    <!-- Word Cloud for Opened Questions -->
    @if (
      surveyService.isOpenedQuestion(question?.typology) &&
      question.content &&
      questionContentLoaded
      ) {
      <div class="row justify-content-center mt-5">
        <img
          class="w-100"
          [src]="
            'https://quickchart.io/wordcloud?height=300&width=600&language=it&removeStopwords=true&fontScale=150&text=' +
            question.content
          "
          />
      </div>
    }

    @if (surveyService.isGridQuestion(question.typology)) {
      <mat-tab-group
        mat-stretch-tabs
        mat-align-tabs="center"
        [(selectedIndex)]="selectedTabIndex"
        >
        @if (heatmapOptions) {
          <mat-tab label="Heatmap">
            <div class="container my-5 justify-content-center row">
              <div class="chart-card w-100">
                <div
                  style="width: 100%; height: 800px"
                  echarts
                  [options]="heatmapOptions"
                ></div>
              </div>
            </div>
          </mat-tab>
        }
        <mat-tab [label]="translateService.instant('generic.pie-charts')">
          <div class="container justify-content-center row">
            @for (row of question.grid_rows; track row) {
              <div class="col-6 mb-4">
                <div class="card h-100">
                  <div class="card-header">{{ row.title }}</div>
                  <div class="card-body p-2">
                    <div style="width: 100%; height: 200px;" echarts [options]="gridChartOptionsMap[row.id]"></div>
                  </div>
                </div>
              </div>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    }
    @if (surveyService.isMultipleChoiceQuestion(question?.typology)) {
      <div class="container my-5 justify-content-center row">
        <div style="width: 100%; height: 400px;" echarts [options]="multipleChoiceChartOptions"></div>
      </div>
    }
    @if (surveyService.isCheckboxQuestion(question?.typology)) {
      <div class="container my-5 justify-content-center row">
        <div style="width: 70%; height: 400px;" echarts [options]="checkboxChartOptions"></div>
      </div>
    }
    @if (surveyService.isConsensusQuestion(question?.typology)) {
      <div class="row">
        <div class="col-6">
          <div style="width: 100%; height: 300px;" echarts [options]="consensusParametersChartOptions"></div>
        </div>
        <div class="col-6">
          <div style="width: 100%; height: 300px;" echarts [options]="consensusChartOptions"></div>
        </div>
      </div>
    }
    @if (surveyService.isQuantitativeQuestion(question?.typology)) {
      <div class="container my-5 justify-content-center row">
        <div style="width: 100%; height: 400px;" echarts [options]="quantitativeChartOptions"></div>
      </div>
      <div class="container justify-content-center row">
        <div class="col-6">
          <div style="width: 100%; height: 300px;" echarts [options]="boxPlotChartOptions"></div>
        </div>
        <div class="col-6">
          <div class="chart-card h-100 d-flex flex-column justify-content-center">
            <mat-table [dataSource]="analyticsFields" class="w-100 bg-transparent">
              <ng-container matColumnDef="parameter">
                <mat-header-cell *matHeaderCellDef class="font-weight-bold"
                  >{{ "generic.parameter" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index">{{
                  element.translateString | translate
                }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="value">
                <mat-header-cell *matHeaderCellDef class="font-weight-bold"
                  >{{ "generic.value" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index">
                  @if (analyticsFields[i].parameter === "mode") {
                    @if (question?.quantitative_results?.mode?.length > 0) {
                      {{ question?.quantitative_results?.mode?.join(", ") }}
                    } @else {
                      N/A
                    }
                  } @else {
                    {{ question?.quantitative_results?.[analyticsFields[i].parameter] ?? 'N/A' }}
                  }
                </mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="['parameter', 'value']"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: ['parameter', 'value']"
              ></mat-row>
            </mat-table>
          </div>
        </div>
      </div>
    }
    <!-- AI Analysis -->
    @if (!viewOnlyChart) {
      <div [ngClass]="isDialog ? 'mt-5' : ''">
        <div *appShowIfOrganizationHasFeature="'virtual_assistant'">
          <app-single-question-ai-analysis
            type="survey"
            [question]="question"
            [surveyId]="surveyId"
            (analysisCompleted)="onAiAnalysisCompleted()"
          />
        </div>
        <!-- Tabella risposte con righe espandibili per testo lungo -->
        <mat-table class="table-primary table-responses-expandable" [dataSource]="responses"
          [multiTemplateDataRows]="hasExpandableRows">
          <!-- Expand Column (solo per risposte con testo lungo) -->
          @if (hasExpandableRows) {
            <ng-container matColumnDef="expand">
              <mat-header-cell *matHeaderCellDef class="expand-column"></mat-header-cell>
              <mat-cell *matCellDef="let element" class="expand-column">
                @if (canExpandRow(element)) {
                  <button mat-icon-button (click)="toggleExpandedRow(element); $event.stopPropagation()"
                    [attr.aria-label]="isRowExpanded(element) ? 'Comprimi' : 'Espandi'">
                    <mat-icon>{{ isRowExpanded(element) ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                }
              </mat-cell>
            </ng-container>
          }
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>{{
              "generic.name" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="font-weight-bold">{{
                showPrivateInfo
                ? (element.name || element.email || 'N/A')
                : ("generic.user" | translate) + " " + getUserDisplayIndex(element)
              }}</span>
            </mat-cell>
          </ng-container>
          <!-- Sentiment Column -->
          <ng-container matColumnDef="sentiment">
            <mat-header-cell *matHeaderCellDef>{{
              "generic.sentiment" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              @if (!element?.score) {
                <mat-icon>sentiment_neutral</mat-icon>
              }
              @if (element?.score > 0) {
                <mat-icon style="color: #00bc1d"
                  >sentiment_satisfied_alt</mat-icon
                  >
                }
                @if (element?.score < 0) {
                  <mat-icon style="color: #ff0000"
                    >sentiment_very_dissatisfied</mat-icon
                    >
                  }
                </mat-cell>
              </ng-container>
              <!-- Answer Column -->
              <ng-container matColumnDef="answer">
                <mat-header-cell *matHeaderCellDef>{{
                  "generic.response" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (hasExpandableRows && surveyService.isQuantitativeQuestion(question?.typology)) {
                    <span class="status-badge" [class.present]="hasAnswer(element)" [class.absent]="!hasAnswer(element)">
                      <mat-icon class="status-icon">{{ hasAnswer(element) ? 'check_circle' : 'remove_circle_outline' }}</mat-icon>
                      {{ element?.answer ?? 'N/A' }}
                    </span>
                  }
                  @if (hasExpandableRows && !surveyService.isQuantitativeQuestion(question?.typology) && !surveyService.isConsensusQuestion(question?.typology)) {
                    <span class="status-badge" [class.present]="hasAnswer(element)" [class.absent]="!hasAnswer(element)">
                      <mat-icon class="status-icon">{{ hasAnswer(element) ? 'check_circle' : 'remove_circle_outline' }}</mat-icon>
                      {{ hasAnswer(element) ? ("generic.answers.yes" | translate) : ("generic.answers.no" | translate) }}
                    </span>
                  }
                  @if (!hasExpandableRows && surveyService.isCheckboxQuestion(question?.typology)) {
                    @if (!element?.answer?.includes("N/A")) {
                      <ul class="m-0 p-0">
                        @for (choice of element?.answer; track choice) {
                          <li>{{ choice }}</li>
                        }
                      </ul>
                    } @else {
                      N/A
                    }
                  }
                  @if (!hasExpandableRows && surveyService.isMultipleChoiceQuestion(question?.typology)) {
                    {{ element?.answer }}<br>{{ element?.open_response_value }}
                  }
                  @if (surveyService.isConsensusQuestion(question?.typology)) {
                    <mat-chip-list>
                      @if (responsesTypeService.isConsensusAgree(element.answer)) {
                        <mat-chip
                          selectable="false"
                      style="
                        justify-content: center;
                        pointer-events: none;
                        background-color: #00bc1d;
                      "
                          class="text-white"
                          >
                          {{ "generic.agree" | translate }}
                        </mat-chip>
                      }
                      @if (
                        responsesTypeService.isConsensusDisagree(element.answer)
                        ) {
                        <mat-chip
                          selectable="false"
                      style="
                        justify-content: center;
                        pointer-events: none;
                        background-color: #ff0000;
                      "
                          class="text-white"
                          >
                          {{ "generic.disagree" | translate }}
                        </mat-chip>
                      }
                      @if (
                        responsesTypeService.isConsensusAbstained(element.answer)
                        ) {
                        <mat-chip
                          selectable="false"
                      style="
                        justify-content: center;
                        pointer-events: none;
                        background-color: rgb(167, 167, 167);
                      "
                          class="text-white"
                          >
                          {{ "generic.abstained" | translate }}
                        </mat-chip>
                      }
                    </mat-chip-list>
                  }
                  @if (
                    !hasExpandableRows &&
                    surveyService.isOpenedQuestion(question?.typology)
                    ) {
                    {{ element.answer }}
                  }
                </mat-cell>
              </ng-container>
              <!-- Feedback Column -->
              <ng-container matColumnDef="feedback">
                <mat-header-cell *matHeaderCellDef>{{
                  "generic.feedback" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (hasExpandableRows) {
                    <span class="status-badge" [class.present]="hasFeedback(element)" [class.absent]="!hasFeedback(element)">
                      <mat-icon class="status-icon">{{ hasFeedback(element) ? 'check_circle' : 'remove_circle_outline' }}</mat-icon>
                      {{ hasFeedback(element) ? ("generic.answers.yes" | translate) : ("generic.answers.no" | translate) }}
                    </span>
                  } @else {
                    {{ element.feedback || "N/A" }}
                  }
                </mat-cell>
              </ng-container>
              <!-- Confidence Column -->
              <ng-container matColumnDef="confidence">
                <mat-header-cell class="small-column" *matHeaderCellDef>
                  {{ "components.proposals.new-proposal.confidence" | translate }}
                </mat-header-cell>
                <mat-cell class="small-column" *matCellDef="let element">
                  <mat-chip-list>
                    <mat-chip>{{ element?.confidence || "N/A" }}</mat-chip>
                  </mat-chip-list>
                </mat-cell>
              </ng-container>
              <!-- Attachments Column -->
              <ng-container matColumnDef="evidences">
                <mat-header-cell *matHeaderCellDef>{{
                  "generic.attachments" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-chip-list>
                    <mat-chip
                  (click)="
                    element?.attachments?.length > 0
                      ? showExpertEvideces(element)
                      : null;
                    $event.stopPropagation()
                  "
                      >
                      {{ element?.attachments?.length }}
                    </mat-chip>
                  </mat-chip-list>
                </mat-cell>
              </ng-container>
              <!-- Expanded Detail Row (solo per risposte con testo lungo) -->
              @if (hasExpandableRows) {
                <ng-container matColumnDef="expandedDetail">
                  <mat-cell *matCellDef="let element" [attr.colspan]="columnsForTypology.length">
                    @if (canExpandRow(element)) {
                    <div class="expanded-detail-content">
                      @if (!surveyService.isQuantitativeQuestion(question?.typology) && !surveyService.isConsensusQuestion(question?.typology) && !surveyService.isGridQuestion(question?.typology)) {
                        <div class="response-detail-item">
                          <span class="response-label">{{ "generic.response" | translate }}:</span>
                          <span class="response-text">
                            @if (surveyService.isMultipleChoiceQuestion(question?.typology)) {
                              {{ element?.answer }}
                              @if (element?.open_response_value) {
                                <br><br>{{ element.open_response_value }}
                              }
                            } @else {
                              {{ element?.answer || 'N/A' }}
                            }
                          </span>
                        </div>
                      }
                      <div class="response-detail-item">
                        <span class="response-label">{{ "generic.feedback" | translate }}:</span>
                        <span class="response-text">{{ element.feedback || "N/A" }}</span>
                      </div>
                    </div>
                    }
                  </mat-cell>
                </ng-container>
              }
              <!-- Table Rows -->
              <mat-header-row
                *matHeaderRowDef="columnsForTypology"
              ></mat-header-row>
              <mat-row
                *matRowDef="let element; columns: columnsForTypology"
                [class.expandable-row]="hasExpandableRows"
                [class.expanded-row]="hasExpandableRows && canExpandRow(element) && isRowExpanded(element)"
                (click)="hasExpandableRows && canExpandRow(element) ? toggleExpandedRow(element) : null"
              ></mat-row>
              @if (hasExpandableRows) {
                <mat-row *matRowDef="let element; columns: ['expandedDetail']"
                  class="detail-row"
                  [class.detail-row-collapsed]="!canExpandRow(element) || !isRowExpanded(element)"
                [class.detail-row-expanded]="canExpandRow(element) && isRowExpanded(element)"></mat-row>
              }
            </mat-table>
          </div>
        }
      </div>
    }

    <!-- Main Content -->
